import { Action } from "redux"

export const INITIALIZE = "WELCOME_INITIALIZE"

export const UPDATE_CONFIGURATION_VISIBILITY =
    "WELCOME_UPDATE_CONFIGURATION_VISIBILITY"
export const REQUEST_WORKSPACES = "WELCOME_REQUEST_WORKSPACES"
export const RECEIVE_WORKSPACES = "WELCOME_RECEIVE_WORKSPACES"

export interface Initialize extends Action {
    greeting: string
    userName: string
    noWorkspacesFoundLabel: string
    noWorkspacesFoundFilteredLabel: string
}

export interface BookmarkAction extends Action {
    bookmark: Models.Bookmark
}

export interface RequestWorkspaces extends Action {
    filter: string
    offset: number
    limit: number
}

export interface ReceiveWorkspaces extends Action {
    workspaces: Models.NavigationWorkspace[]
    hasMore: boolean
}

export const initialize = (
    greeting: string,
    userName: string,
    noWorkspacesFoundLabel: string,
    noWorkspacesFoundFilteredLabel: string,
): Initialize => ({
    type: INITIALIZE,
    greeting,
    userName,
    noWorkspacesFoundLabel,
    noWorkspacesFoundFilteredLabel,
})

export const requestWorkspaces = (
    filter: string,
    offset: number,
    limit: number,
): RequestWorkspaces => ({ type: REQUEST_WORKSPACES, filter, offset, limit })

export const receiveWorkspaces = (
    workspaces: Models.NavigationWorkspace[],
    hasMore: boolean,
): ReceiveWorkspaces => ({ type: RECEIVE_WORKSPACES, workspaces, hasMore })

export const REQUEST_GRID = "WELCOME_REQUEST_GRID"
export const RECEIVE_GRID = "WELCOME_RECEIVE_GRID"

export interface ReceiveWelcomePageGrid extends Action {
    grid: Grids.Grid
}

export const requestWelcomePageGrid = (): Action => ({
    type: REQUEST_GRID,
})

export const receiveWelcomePageGrid = (
    grid: Grids.Grid,
): ReceiveWelcomePageGrid => ({
    type: RECEIVE_GRID,
    grid,
})

export const UPDATE_TILES_ORDER = "WELCOME_GRID_UPDATE_TILES_ORDER"

export interface UpdateTilesOrder extends Action {
    targetIndex: number
    oldIndex: number
    reorderedTileId: number
    targetTileId: number
}

export const updateTilesOrder = (
    targetIndex: number,
    oldIndex: number,
    reorderedTileId: number,
    targetTileId: number,
): UpdateTilesOrder => ({
    type: UPDATE_TILES_ORDER,
    targetIndex,
    oldIndex,
    reorderedTileId,
    targetTileId,
})

export const REMOVE_TILE = "WELCOME_REMOVE_TILE"

export interface RemoveTile extends Action {
    tileId: number
}

export const removeTile = (tileId: number): RemoveTile => ({
    type: REMOVE_TILE,
    tileId,
})

export const mapDispatchToProps = {
    initialize,
    receiveWorkspaces,
    requestWorkspaces,
    receiveWelcomePageGrid,
    requestWelcomePageGrid,
    removeTile,
    updateTilesOrder,
}

export type DispatchProps = typeof mapDispatchToProps
